import React from "react";

const TextHighlighter = ({ text, highlight, className }) => {
  if (!highlight) {
    return <div className={className}>{text}</div>;
  }

  const regex = new RegExp(`(${highlight})`, "gi");
  const parts = String(text ?? "").split(regex);
  const keyword = highlight.toLowerCase();

  return (
    <div className={className}>
      {parts.map((part, index) =>
        part.toLowerCase() === keyword ? (
          <span
            key={index}
            style={{
              fontWeight: "bold",
              backgroundColor: "rgba(212, 175, 55, 0.32)",
              color: "#fff3cf",
              borderRadius: 3,
            }}
          >
            {part}
          </span>
        ) : (
          <React.Fragment key={index}>{part}</React.Fragment>
        )
      )}
    </div>
  );
};

export default TextHighlighter;
